import { useTranslation } from "react-i18next";

const transactionCurrencyCodeOptions = (list, includeCurrencyCode) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "hkd",
      title: t("options.currencyCode.hkd"),
      codeTitle: t("options.currencyCodeWithCode.hkd"),
      value: "344",
    },
    {
      key: "usd",
      title: t("options.currencyCode.usd"),
      codeTitle: t("options.currencyCodeWithCode.usd"),
      value: "840",
    },
    {
      key: "sgd",
      title: t("options.currencyCode.sgd"),
      codeTitle: t("options.currencyCodeWithCode.sgd"),
      value: "702",
    },
    {
      key: "eur",
      title: t("options.currencyCode.eur"),
      codeTitle: t("options.currencyCodeWithCode.eur"),
      value: "978",
    },
    {
      key: "jpy",
      title: t("options.currencyCode.jpy"),
      codeTitle: t("options.currencyCodeWithCode.jpy"),
      value: "392",
    },
    {
      key: "gbp",
      title: t("options.currencyCode.gbp"),
      codeTitle: t("options.currencyCodeWithCode.gbp"),
      value: "826",
    },
    {
      key: "cad",
      title: t("options.currencyCode.cad"),
      codeTitle: t("options.currencyCodeWithCode.cad"),
      value: "124",
    },
    {
      key: "aud",
      title: t("options.currencyCode.aud"),
      codeTitle: t("options.currencyCodeWithCode.aud"),
      value: "036",
    },
    {
      key: "thb",
      title: t("options.currencyCode.thb"),
      codeTitle: t("options.currencyCodeWithCode.thb"),
      value: "764",
    },
    {
      key: "vnd",
      title: t("options.currencyCode.vnd"),
      codeTitle: t("options.currencyCodeWithCode.vnd"),
      value: "704",
    },
    {
      key: "twd",
      title: t("options.currencyCode.twd"),
      codeTitle: t("options.currencyCodeWithCode.twd"),
      value: "901",
    },
    {
      key: "krw",
      title: t("options.currencyCode.krw"),
      codeTitle: t("options.currencyCodeWithCode.krw"),
      value: "410",
    },
    {
      key: "idr",
      title: t("options.currencyCode.idr"),
      codeTitle: t("options.currencyCodeWithCode.idr"),
      value: "360",
    },
    {
      key: "php",
      title: t("options.currencyCode.php"),
      codeTitle: t("options.currencyCodeWithCode.php"),
      value: "608",
    },
    {
      key: "lkr",
      title: t("options.currencyCode.lkr"),
      codeTitle: t("options.currencyCodeWithCode.lkr"),
      value: "146",
    },
    {
      key: "kwp",
      title: t("options.currencyCode.kwp"),
      codeTitle: t("options.currencyCodeWithCode.kwp"),
      value: "146",
    },
    {
      key: "mop",
      title: t("options.currencyCode.mop"),
      codeTitle: t("options.currencyCodeWithCode.mop"),
      value: "146",
    },
  ];

  if (includeCurrencyCode) {
    options.forEach((option) => {
      option.title = option.codeTitle;
      delete option.codeTitle;
    });
  } else {
    options.forEach((option) => {
      delete option.codeTitle;
    });
  }

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default transactionCurrencyCodeOptions;
